import * as marietta from '../../..';
import { ShitaeControllerDialog } from '.';

/**
 * 下絵編集ダイアログ（移動のみ）
 */
class ShitaeControllerDialog2 extends ShitaeControllerDialog {
  // eslint-disable-next-line no-useless-constructor
  constructor(draggable: boolean) {
    super(draggable);
  }

  /**
     * 初期設定
     */
  init() {
    // モーダルカラーを薄くする
    document.getElementById('modalBg').style.backgroundColor = '#000';
    document.getElementById('modalBg').style.opacity = '0.2';

    // 対象の下絵を登録
    const { currentFloor } = marietta.webcad.WebCADGlobal.webcad2Dmanager;
    this.targetLayer = (marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(currentFloor, true) as marietta.webcad.layer.FloorShitaeLayer).layer_shitae;
    // eslint-disable-next-line prefer-destructuring
    this.targetItem = this.targetLayer.childList[0] as marietta.webcad.item.Shitae;

    // 下絵の状態を保持（リセット用）
    this.targetLayer.defaultScale = this.targetItem.spt.scaleX;
    this.targetLayer.defaultItemInfo = Object.assign(this.targetLayer.defaultItemInfo, this.targetItem.itemInfo);

    const id = 'dialogShitaeController2';
    let title = '';
    // タイトル
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'en': title = 'Edit Picture Position'; break;
      default: title = '下絵の位置の設定'; break;
    }

    let contents = '';
    contents += '<div class="controllerLeft">\n';
    contents += '<p class="controllerSubttl"><span class="jp">位置移動</span><span class="en">Move</span></p>\n';
    contents += '<div class="btnMoveWrap">\n';
    contents += '<button id="shitaeMoveUp" class="btnShitaeTransform btnUp">↑</button>\n';
    contents += '<button id="shitaeMoveDown" class="btnShitaeTransform btnDown">↓</button>\n';
    contents += '<button id="shitaeMoveLeft" class="btnShitaeTransform btnLeft">←</button>\n';
    contents += '<button id="shitaeMoveRight" class="btnShitaeTransform btnRight">→</button>\n';
    contents += '<div id="shitaeMoveCenter" class="capCenter"></div>\n';
    contents += '</div>\n';
    contents += '</div>\n';

    const footer = '<button id="shitaeTransformConfirm">OK</button>';

    this.createDialog(id, title, contents, footer);

    // アクション
    const self = this;
    let ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      document.querySelectorAll('.btnShitaeTransform').forEach((element) => {
        element.addEventListener('touchstart', self.onMouseDownTransform);
      });
    } else {
      document.querySelectorAll('.btnShitaeTransform').forEach((element) => {
        element.addEventListener('mousedown', self.onMouseDownTransform);
      });
    }
    document.getElementById('shitaeTransformConfirm').addEventListener('click', self.controlHandlerTransformConfirm);

    ua = null;

    // キャプチャのサムネイル読み込み
    const { imgSrc } = this.targetLayer;
    this.loadThumbnail(imgSrc);
  }
}

export default ShitaeControllerDialog2;
